<template>
  <span v-html="translated"></span>
</template>

<script>
export default {
    props: ['keys'],
    name: 'translatable',
    computed: {
      translated() {
        if ( typeof this.keys === 'object' ) {
          this.keys = this.keys.map( (item) => {
            return 'contentful||' + item;
          }).concat(this.keys);
        }
        return md.render(i18.t(this.keys));
      },
    },
  };
</script>
